<template>
  <SAIStickyPageTabs
    :disable="disableNavigation"
    class="print-hide"
    :value="currentTab"
    :tabs="tabs"
    @click:tab="tabSelected"
    single-column-desktop-width
  />
</template>

<script>
import { SAIStickyPageTabs } from 'ecx.saigon.ui.common';
import { mapState, mapGetters } from 'vuex';
import getValidRote from '@/utils/get-valid-route';
import validations from '@/utils/validations/page-validations';
import getUserFeatures from '@/utils/user-features';

export default {
  name: 'CarSearchTabsWidget',
  data() {
    return {
      routeTabs: {}
    };
  },
  computed: {
    ...mapState({
      application: (state) => state.application.application,
      carSearch: (state) => state.carSearch.selected,
      quote: (state) => state.quote.quote,
      disableNavigation: (state) => state.ui.disableNavigation,
      vehicleCondition: (state) =>
        state.application.application.metaData.customerOptions.vehicleCondition
    }),
    ...mapGetters('quote', ['isExistingQuoteOpen']),
    ...mapGetters('carSearch', ['isNew']),
    userFeatures() {
      return getUserFeatures();
    },
    currentTab: function () {
      if (
        !this.$router.currentRoute ||
        !this.routeTabs[this.$router.currentRoute.name]
      ) {
        return undefined;
      }
      return this.routeTabs[this.$router.currentRoute.name].name;
    },
    tabs() {
      const payload = {
        application: this.application,
        carSearch: this.carSearch,
        quote: this.quote
      };
      const names = this.$RouteNames;
      const searchComplete = validations[names.carSearch](payload);
      const variantComplete = validations[names.carSearchVariant](payload);
      const uploadComplete = validations[names.quoteUpload](payload);
      const extrasComplete = validations[names.carColourAndExtras](payload);
      const dealerComplete = validations[names.dealerPrice](payload);
      const summaryComplete = validations[names.summary](payload);
      const tabs = [];
      tabs.push({
        ...this.allTabs.findTheCarYouWant,
        progress:
          variantComplete || uploadComplete ? 100 : searchComplete ? 50 : 0
      });
      if (searchComplete && this.isNew) {
        tabs.push({
          ...this.allTabs.accessories,
          progress: extrasComplete ? 100 : 0
        });
      }
      tabs.push({
        ...this.allTabs.yourQuote,
        progress: summaryComplete ? 100 : dealerComplete ? 50 : 0
      });
      return tabs;
    },
    allTabs() {
      return {
        findTheCarYouWant: {
          name: 'findTheCarYouWant',
          label: 'Choose your car',
          to: this.$RouteNames.carSearch
        },
        accessories: {
          name: 'accessories',
          label: 'Accessories',
          to: this.$RouteNames.carColourAndExtras
        },
        yourQuote: {
          name: 'yourQuote',
          label: 'Your Quote',
          disable: !this.isExistingQuoteOpen,
          to: this.$RouteNames.dealerPrice
        }
      };
    }
  },
  methods: {
    tabSelected(tab) {
      let route = getValidRote(this.allTabs[tab].to);
      if (route !== this.$router.currentRoute.name) {
        this.$router.push({
          name: route,
          params: { ...this.$router.currentRoute.params }
        });
      }
    }
  },
  beforeMount() {
    this.routeTabs = {
      [this.$RouteNames.carSearch]: this.allTabs.findTheCarYouWant,
      [this.$RouteNames.carSearchVariant]: this.allTabs.findTheCarYouWant,
      [this.$RouteNames.quoteUpload]: this.allTabs.findTheCarYouWant,
      [this.$RouteNames.carColourAndExtras]: this.allTabs.accessories,
      [this.$RouteNames.dealerPrice]: this.allTabs.yourQuote,
      [this.$RouteNames.summary]: this.allTabs.yourQuote
    };
  },
  components: {
    SAIStickyPageTabs
  }
};
</script>
